import { UNSTABLE_ToastRegion as ToastRegion } from 'react-aria-components';
import styled from 'styled-components';

export const Region: typeof ToastRegion = styled(ToastRegion)`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 10000;
  display: flex;
  flex-direction: column-reverse;
  gap: 8px;
  border-radius: var(--spacing-base);
  outline: none;

  &[data-focus-visible] {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);
    outline: none;
  }

  & .react-aria-Toast {
    padding: 60px 16px 16px;
    background: var(--brand-300);
    border: 1px solid var(--black);
    border-radius: var(--radius-xlarge);
    position: relative;

    &[data-focus-visible] {
      box-shadow: var(--shadow-focus);
      border: 1px solid var(--brand-600);
      outline: none;
    }

    & .react-aria-ToastContent {
      background: var(--white);
      border-radius: var(--radius-base);
    }

    & .react-aria-Button[slot=close] {
      background: none;
      border: none;
      appearance: none;
      border-radius: var(--radius-fullyrounded);
      height: 24px;
      width: 24px;
      position: absolute;
      top: 16px;
      right: 16px;

      &[data-focus-visible] {
        box-shadow: var(--shadow-focus);
        border: 1px solid var(--brand-600);
        outline: none;
      }

      & svg {
        width: 24px;
        height: 24px;
      }
    }
  }

  @media (width >= 48rem) {
    top: var(--spacing-base);
    right: var(--spacing-base);
  }
`;

export const NotificationMessage = styled.p<{ $isError?: boolean }>`
  width: 100%;
  max-width: 330px;
  padding: 24px;
  background: var(--white);
  ${props =>
    props.$isError
      ? `
    border: 2px solid var(--error-600);
    `
      : ''}

  @media (width >= 48rem) {
    width: 330px;
    max-width: calc(100vw - 32px);
  }
`;
